import React, { FC, useCallback, useMemo, ReactChild } from 'react'

import APP from '../../configuration/app'
import { NavPushProps } from '../NavPush'
import { TextLinkProps } from '../A'

import * as SC from './styled'

export type NavMenuProps = {
  className?: string
  links?: {
    link?: TextLinkProps
    push?: NavPushProps
    levelTwo?: {
      link?: TextLinkProps
      isCurrent?: boolean
      levelThree?: {
        link?: TextLinkProps
        isCurrent?: boolean
      }[]
    }[]
    isSeparated?: boolean
    isCurrent?: boolean
  }[]
  push?: NavPushProps[]
  children?: ReactChild
  currentLevelOneOpen?: number
}

export type NavLevelOneProps = {
  onHoverHandler?: (index: number) => void
  onLeaveHandler?: () => void
}

const NavMenu: FC<NavMenuProps & NavLevelOneProps> = (props) => {
  const {
    className,
    links,
    onHoverHandler,
    onLeaveHandler,
    children,
    currentLevelOneOpen,
  } = props

  const handleHover = useCallback(
    (index) => {
      onHoverHandler && onHoverHandler(index)
    },
    [onHoverHandler]
  )

  const handleLeave = useCallback(() => {
    onLeaveHandler && onLeaveHandler()
  }, [onLeaveHandler])

  const renderLevelOne = useMemo(
    () =>
      links && (
        <SC.Links>
          {links?.map((item, index) => {
            if (item?.link?.text === APP.SPECIAL_MENU_LABEL) {
              return null
            }
            return (
              <SC.LinksItem
                key={`menu-lvl1-${index}`}
                isSeparated={item.isSeparated}
                onMouseEnter={() => handleHover(index)}
              >
                <SC.LinksLink
                  {...item.link}
                  isCurrent={item.isCurrent}
                  $currentLevelOneOpen={currentLevelOneOpen === index}
                >
                  {item.link?.text}
                </SC.LinksLink>
              </SC.LinksItem>
            )
          })}
        </SC.Links>
      ),
    [currentLevelOneOpen, handleHover, links]
  )

  return (
    <SC.Container className={className} onMouseLeave={() => handleLeave()}>
      {renderLevelOne}
      {children}
    </SC.Container>
  )
}

export default NavMenu
